import { render } from "./FDMessage.vue?vue&type=template&id=5b28c858&scoped=true"
import script from "./FDMessage.vue?vue&type=script&lang=js"
export * from "./FDMessage.vue?vue&type=script&lang=js"

import "./FDMessage.vue?vue&type=style&index=0&id=5b28c858&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b28c858"]])

export default __exports__